if (
  typeof __webpack_require__ !== 'undefined' &&
  __webpack_require__.f &&
  __webpack_require__.miniCssF
) {
  const originalMiniCss = __webpack_require__.f.miniCss;

  __webpack_require__.f.miniCss = function (chunkId, promises) {
    const cssFilename = __webpack_require__.miniCssF(chunkId);

    if (/vendors(\.[a-z0-9]+)?\.css$/.test(cssFilename)) {
      return;
    }

    return originalMiniCss(chunkId, promises);
  };
}
